import {
  CompanyProfile,
  CompanyProfileActiveJobs,
  TopbarContainer,
  TopbarTitle,
} from "@/components";

import { useCurrentCompanyId } from "@/hooks";
import { storage } from "@/lib/storage";

export const CompanyProfilePage = () => {
  const currentCompanyId = useCurrentCompanyId();
  const user = storage.getUser();

  // TODO: This is a common pattern so we should create a reusable piece of logic.
  if (!user) {
    throw new Error("User not found in local storage");
  }

  // TODO: This is a common pattern so we should create a reusable piece of logic.
  const currentCompany = user.companies.find(
    (company) => company.id === currentCompanyId,
  );
  if (!currentCompany) {
    throw new Error("Current company not found in user's companies");
  }

  return (
    <div className="flex h-full flex-col">
      <TopbarContainer>
        <TopbarTitle>Company profile</TopbarTitle>
      </TopbarContainer>
      <div className="flex flex-1">
        <CompanyProfile
          className="w-[70%] border-r border-slate-200 p-6"
          company={currentCompany}
        />
        <CompanyProfileActiveJobs
          className="w-[30%] p-6"
          company={currentCompany}
        />
      </div>
    </div>
  );
};
